import { render, staticRenderFns } from "./TractFilterChips.vue?vue&type=template&id=f8a2d27e&"
import script from "./TractFilterChips.vue?vue&type=script&lang=js&"
export * from "./TractFilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports